import React, { Fragment } from 'react'
import ErrorBoundary from '../../../ErrorBoundry'
import { Col, Row } from 'reactstrap'
import { Typography } from '@mui/material'
import { Icon } from '@progress/kendo-react-common'
import SupervisorNotificationList from './SupervisorNotificationList'

const SupervisorDashboard = () => {
  return (
    <ErrorBoundary>
      {" "}
      <Fragment>
      <Row className="bg-primary  py-2 mb-3 mt-0">
          <Typography
            variant="h5"
            style={{ display: "flex", alignItems: "center" }}
          >
            {/* <i class="fa-duotone fa-table-columns m-r-10"></i> */}
            
              <Icon
                size="medium"
                style={{
                  fontSize: "25px",
                  margin: "10px",
                }}
                name="file-report"
              />
            Dashboard
          </Typography>
        </Row>
        <Row>
            <Col sm="12" className="page-content">
            <SupervisorNotificationList />
            </Col>
            </Row>
      </Fragment>
      </ErrorBoundary>
  )
}

export default SupervisorDashboard